export default __webpack_public_path__ + "static/dark-corners-323bbf8d9fe761f81060387ebf34c6ba.jpg";